module.exports = __webpack_public_path__ + "img/ecs-aws.91c6c5a4.png";